import L from 'leaflet';
import omnivore from '@mapbox/leaflet-omnivore';
// import { showCaption, cleanCaptionList } from '../components/caption';
import InfoMap from '../components/infoMap';

const md = "960px";
const isMobile = window.matchMedia(`(max-width: ${md})`).matches;
let map = null;

function showToolTip(data, event) {
  if (data) {
    const dataTooltip = {
      nameProvince: event.target.feature.properties.Name,
      dataVoting: data[event.target.feature.properties.Id],
    };

    if (dataTooltip.dataVoting && dataTooltip.dataVoting.voting.votesCountedPct > 0) {
      InfoMap.showMapInfo(dataTooltip);
    }
  }
}

function goToArea(data, feature) {
  if (
    !isMobile &&
    data[feature.properties.Id] &&
    data[feature.properties.Id].url
  ) {
    window.open(data[feature.properties.Id].url, "_self");
  }
}

function drawMap(id, data, boundariesUrl, initialView, useBoundaries, moduleContainer = null) {
  if (map) {
    map.remove();
    InfoMap.hideMapInfo();
    // cleanCaptionList('.ac-mostVotedParty .c-leyenda__list');
  }

  map = L.map(id, {
    zoomControl: false,
    attributionControl: false,
    center: initialView.center,
    maxZoom: 13,
  });

  map.dragging.disable();
  map.touchZoom.disable();
  map.doubleClickZoom.disable();
  map.scrollWheelZoom.disable();

  if (map.tap) map.tap.disable();

  const areasLayers = [];
  const provinciasCustomLayer = L.geoJson(null, {
    style(feature) {
      const provinceCode = feature.properties.Id;
      let atenuado = false;
      let ganador = {};

      if (data) {
        if (data[provinceCode] && data[provinceCode].parties.length > 0) {
          ganador = data[provinceCode].parties[0] || {};
          if (ganador.votes === 0) {
            ganador = {};
          }
          // } else {
          //   // showCaption(ganador, '.ac-mostVotedParty .c-leyenda__list');
          // }
        } else {
          atenuado = true;
        }
      }

      return {
        fillColor: '#ccc',
        className: [
          'provincia',
          'fade-out',
          'color-base',
          ganador.partyCode ? ganador.partyCode : 'sinasignar',
          atenuado ? 'atenuado' : '',
        ].join(' '),
      };
    },
    onEachFeature(feature, layer) {
      areasLayers.push(layer);
      layer.on('mouseover', (event) => {
        showToolTip(data, event);
      });
      layer.on('mousemove', (event) => {
        showToolTip(data, event);
      });
      layer.on('mouseout', () => {
        // InfoMap.hideMapInfo();
      });
      layer.on("click", () => goToArea(data, feature));
    },
  });

  const boundaries = omnivore.topojson(boundariesUrl, null, provinciasCustomLayer);
  boundaries.addTo(map);

  if (useBoundaries) {
    const boundariesReady = () => {
      const bounds = boundaries.getBounds();
      const center = bounds.getCenter();
      map.setView(center, initialView.zoom);

      if (moduleContainer) {
        const { style } = moduleContainer;
        style.minHeight = 'initial';
      }
    };

    boundaries.on('ready', L.bind(boundariesReady, this, areasLayers));
  }
}

module.exports = {
  drawMap,
};
